import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';
import SeparatorLine from '@components/SeparatorLine';
import ActionLabel from '@components/ActionLabel';
import Container from './components/Container';
import TextContainer from './components/TextContainer';
import TextLabel from './components/TextLabel';

function Subtitle({
  label,
  separator,
  actionText,
  onActionClick,
  style,
  marginBottom,
  withMarginTop,
  className,
}) {
  return (
    <Container
      className={className}
      marginBottom={marginBottom}
      withMarginTop={withMarginTop}
    >
      <TextContainer>
        <TextLabel style={style}>{label}</TextLabel>
        {actionText && onActionClick && (
          <SimpleButton
            onClick={onActionClick}
            label={actionText}
            color={COLOR.TERTIARY}
            size={SIZE.SMALL}
          />
        )}
        {actionText && !onActionClick && <ActionLabel label={actionText} />}
      </TextContainer>
      {separator && <SeparatorLine />}
    </Container>
  );
}

Subtitle.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  actionText: PropTypes.string,
  style: PropTypes.object,
  separator: PropTypes.bool,
  onActionClick: PropTypes.func,
  marginBottom: PropTypes.bool,
  withMarginTop: PropTypes.bool,
};

Subtitle.defaultProps = {
  separator: true,
  actionText: null,
  onActionClick: null,
  style: {},
  marginBottom: true,
  withMarginTop: false,
};

export default styled(Subtitle)``;
